(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
/*
class AnnouncementSlider {
  constructor(selector) {
    this.bars = Array.from(document.querySelectorAll(selector));
    this.validArray = this.filterValidElements();
    this.currentIndex = null;

    if (this.validArray.length > 0) {      
      this.unhideAnnouncement(0);
      this.setupAutoCycle();
    }
  }

  filterValidElements() {
    return this.bars.filter(this.checkIfValid);
  }

  checkIfValid = bar => {
    const element = bar.querySelector('.announcement--text');
    return element ? element.innerText.trim() !== '' : false;
  };

  hideAllAnnouncements() {
    this.bars.forEach(bar => bar.classList.add('hide'));
  }

  unhideAnnouncement(index) {
    this.validArray[index].classList.remove('hide');
    this.currentIndex = index;
  }
  

  setupAutoCycle() {
    if (this.validArray.length > 1) {
      this.autoCycleInterval = setInterval(() => this.cycleAnnouncements(), 6000);     
    }
      
    else {      
      this.bars.forEach(bar => {
        const element = bar.querySelector('.announcement--text');
        element.classList.add('remove-animation');        
      });
    }
  }

  cycleAnnouncements() {
    const newIndex = (this.currentIndex + 1) % this.validArray.length;
    this.hideAllAnnouncements();
    this.unhideAnnouncement(newIndex);
  }
  
  stopAutoCycle() {
    clearInterval(this.autoCycleInterval);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const slider = new AnnouncementSlider('.announcement-element');
  
});
*/

class AnnouncementSlider {
  constructor(selector) {
    // grab _all_ announcement elements (might be zero)
    this.bars = Array.from(document.querySelectorAll(selector));

    // nothing to do if no bars found
    if (this.bars.length === 0) return;

    // filter out any bar that either:
    //  • lacks a .announcement--text node, or
    //  • whose trimmed text is empty
    this.validBars = this.bars.filter(bar => {
      const txtEl = bar.querySelector('.announcement--text');
      return Boolean(txtEl?.textContent.trim());
    });

    // if after filtering we have nothing, bail out
    if (this.validBars.length === 0) return;

    this.currentIndex = 0;
    this.showBar(this.currentIndex);
    this.setupAutoCycle();
  }

  showBar(index) {
    // hide _all_ valid bars except the one at `index`
    this.validBars.forEach((bar, i) => {
      bar.classList.toggle('hide', i !== index);
    });
  }

  setupAutoCycle() {
    // if there's more than one announcement, auto-cycle them
    if (this.validBars.length > 1) {
      this.autoCycleInterval = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.validBars.length;
        this.showBar(this.currentIndex);
      }, 6000);
    } else {
      // otherwise remove the loading/animation class on the single item
      const singleText = this.validBars[0].querySelector('.announcement--text');
      singleText?.classList.add('remove-animation');
    }
  }

  stopAutoCycle() {
    clearInterval(this.autoCycleInterval);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // pass the class you already have on each block
  new AnnouncementSlider('.announcement-element');
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
class Carousel {
  constructor() {
    this.sliderProducts = document.querySelectorAll('.slider-product');
    this.sliderButtons = document.querySelectorAll('.pagination-dot');
    this.slideTotal = this.sliderProducts.length;
    this.currentActive = 0;
    this.interactions = 0;

    addEventListener('mousemove', () => this.interactions++);
    addEventListener('keypress', () => this.interactions++);

    setInterval(this.chooseNextSlide.bind(this), 1000);

    this.sliderButtons.forEach((b) => {
      b.addEventListener('click', (e) => {
        const buttonNumber = parseInt(e.target.dataset.number);
        this.activateSlide(buttonNumber);
      });
    });
  }

  activateSlide(number) {
    this.hideProducts();
    this.inactiveButtons();
    this.showProduct(number);
    this.makeActive(number);
    this.currentActive = number;
  }

  hideProducts() {
    this.sliderProducts.forEach((p) => {
      p.classList.add('hide');
    });
  }

  inactiveButtons() {
    this.sliderButtons.forEach((b) => {
      b.classList.remove('dot-selected');
    });
  }

  showProduct(number) {
    document
      .querySelector(`.slider-product[data-number="${number}"]`)
      .classList.remove('hide');
  }

  makeActive(number) {
    document
      .querySelector(`.pagination-dot[data-number="${number}"]`)
      .classList.add('dot-selected');
  }

  chooseNextSlide() {
    if (this.interactions === 0 && this.currentActive < this.slideTotal) {
      // Next slide
      this.activateSlide(this.currentActive + 1);
    } else if (this.interactions === 0 && this.currentActive === this.slideTotal) {
      // Back to slide 1
      this.activateSlide(1);
    }
    this.interactions = 0;
  }
}

const slider = new Carousel();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-b2b-form"] && !Shopify.designMode) return;
  try {
    
  const englishForm = document.querySelector('.lc-b2b-language[data-english-form-url]');
  if (englishForm) {
    document.querySelectorAll('#lisa-b2b-page a[href="#lc-b2b-form-section"]').forEach((link) => {
      link.href = englishForm.dataset.englishFormUrl;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisa-return-guide"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(scope){
      scope.querySelectorAll('[data-lc-guide]').forEach(function(root){
        if(root.dataset.ready==='1')return;
        root.dataset.ready='1';
        const field=name=>root.querySelector('[data-field="'+name+'"]');
        const value=name=>field(name)?field(name).value:'';
        const copy=name=>{const node=root.querySelector('[data-copy="'+name+'"]');return node?node.textContent.trim():''};
        const replace=(str,data)=>str.replace(/\{(\w+)\}/g,(_,key)=>Object.prototype.hasOwnProperty.call(data,key)?data[key]:'');
        const parse=raw=>{
          let y,m,day;
          if(/^\d{2}\.\d{2}\.\d{4}$/.test(raw)){const p=raw.split('.').map(Number);day=p[0];m=p[1];y=p[2]}
          else if(/^\d{4}-\d{2}-\d{2}$/.test(raw)){const p=raw.split('-').map(Number);y=p[0];m=p[1];day=p[2]}
          else return null;
          const d=new Date(Date.UTC(y,m-1,day));
          return y>=1900&&d.getUTCFullYear()===y&&d.getUTCMonth()===m-1&&d.getUTCDate()===day?d:null;
        };
        const todayDate=()=>{const now=new Date();return new Date(Date.UTC(now.getFullYear(),now.getMonth(),now.getDate()))};
        const numeric=d=>[String(d.getUTCDate()).padStart(2,'0'),String(d.getUTCMonth()+1).padStart(2,'0'),d.getUTCFullYear()].join('.');
        const refreshToday=()=>{const d=todayDate();field('today').value=numeric(d);return d};
        const addDays=(d,n)=>{const r=new Date(d.getTime());r.setUTCDate(r.getUTCDate()+n);return r};
        const addYears=(d,n)=>{const y=d.getUTCFullYear()+n,m=d.getUTCMonth(),day=Math.min(d.getUTCDate(),new Date(Date.UTC(y,m+1,0)).getUTCDate());return new Date(Date.UTC(y,m,day))};
        const weekendExtension=d=>{let r=new Date(d.getTime());while(r.getUTCDay()===0||r.getUTCDay()===6)r=addDays(r,1);return r};
        const fmt=d=>new Intl.DateTimeFormat(root.dataset.language.toLowerCase().startsWith('ro')?'ro-RO':'en-GB',{day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(d);
        const show=(name,visible)=>root.querySelectorAll('[data-conditional="'+name+'"]').forEach(node=>{node.hidden=!visible});
        const update=()=>{const reason=value('purpose'),w=reason==='withdrawal'||reason==='both',p=reason==='problem'||reason==='both';show('withdrawal',w);show('notice-date',w&&value('notice')==='yes');show('problem',p);show('outlet-flaw',p&&value('outlet')==='yes')};
        const result=root.querySelector('[data-result]');
        const paragraph=(parent,text,className)=>{if(!text)return;const p=document.createElement('p');p.textContent=text;if(className)p.className=className;parent.appendChild(p)};
        const card=(title,groups)=>{const article=document.createElement('article'),h=document.createElement('h3');h.textContent=title;article.appendChild(h);groups.forEach(group=>{if(group.heading){const heading=document.createElement('h4');heading.textContent=copy(group.heading);article.appendChild(heading)}group.lines.filter(Boolean).forEach(line=>paragraph(article,line))});result.appendChild(article)};
        const finish=()=>{paragraph(result,copy('not_sent'),'lc-guide-alert');paragraph(result,copy('contact'));paragraph(result,copy('footer'))};
        const report=()=>{
          result.replaceChildren();result.hidden=false;
          const today=refreshToday(),residence=value('residence'),delivery=value('delivery'),channel=value('channel'),purpose=value('purpose');
          if(!residence||!delivery||!channel||!purpose||!value('receipt')){paragraph(result,copy('missing'),'lc-guide-alert');return}
          const receipt=parse(value('receipt'));
          if(!receipt||receipt>today){paragraph(result,copy('invalid_date'),'lc-guide-alert');return}
          const wantsWithdrawal=purpose==='withdrawal'||purpose==='both',wantsProblem=purpose==='problem'||purpose==='both';
          const noticed=wantsProblem?parse(value('problem_date')):null,contract=wantsProblem?parse(value('contract_date')):null;
          if(wantsProblem&&(!value('problem_date')||!value('contract_date'))){paragraph(result,copy('missing'),'lc-guide-alert');return}
          if(wantsProblem&&(!noticed||noticed<receipt||noticed>today||!contract||contract>receipt)){paragraph(result,copy('invalid_date'),'lc-guide-alert');return}
          if(wantsWithdrawal&&channel==='online'&&value('notice')==='yes'){
            const noticeDate=parse(value('notice_date'));
            if(!noticeDate||noticeDate>today){paragraph(result,copy('invalid_date'),'lc-guide-alert');return}
          }
          paragraph(result,replace(copy('receipt_date'),{date:fmt(receipt)}));
          if(residence!=='ro'||delivery!=='ro')paragraph(result,copy('foreign'),'lc-guide-alert');
          if(channel==='unknown'||purpose==='unknown'){paragraph(result,copy('manual'));finish();return}
          if(purpose==='both')paragraph(result,copy('both'));
          if(wantsWithdrawal){
            const terms=[],groups=[];
            if(channel==='showroom')terms.push(copy('showroom'));
            else if(channel==='fair')terms.push(copy('fair'));
            else{
              const deadline=weekendExtension(addDays(receipt,14)),notice=value('notice');
              let inTime=false;
              if(notice==='yes'){
                const noticeDate=parse(value('notice_date'));
                if(noticeDate<receipt)terms.push(copy('online_prior'));
                else if(noticeDate<=deadline){
                  const returnDate=weekendExtension(addDays(noticeDate,14));
                  inTime=today<=returnDate;
                  terms.push(replace(copy(inTime?'online_notice':'return_overdue'),{date:fmt(returnDate)}));
                }else terms.push(copy('online_late'));
              }else if(notice==='no'&&today<=deadline){inTime=true;terms.push(replace(copy('online_open'),{date:fmt(deadline)}))}
              else if((!notice||notice==='unknown')&&today<=deadline){inTime=true;terms.push(replace(copy('online_unsure'),{date:fmt(deadline)}))}
              else terms.push(copy('online_late'));
              const needsCheck=value('custom')!=='no';
              if(needsCheck)terms.push(copy('exception'));
              if(inTime&&!needsCheck){
                groups.push({heading:'transport_heading',lines:[copy('withdrawal_shipping')]});
                const whole=value('whole');
                groups.push({heading:'refund_heading',lines:[copy(whole==='yes'?'shipping_whole':whole==='no'?'shipping_partial':'shipping_unknown'),copy('refund_timing'),copy('handling')]});
                groups.push({heading:'next_heading',lines:[copy('withdrawal_next')]});
              }else groups.push({heading:'next_heading',lines:[copy('withdrawal_review_next')]});
            }
            groups.unshift({heading:'term_heading',lines:terms});
            card(copy('withdrawal_title'),groups);
          }
          if(wantsProblem){
            const terms=[copy('problem_assessment')],legacy=contract<parse('2022-01-01');
            const older=noticed>addYears(receipt,2)||today>addYears(receipt,2);
            if(legacy)terms.push(copy('problem_old'));
            else{
              if(noticed<=addDays(receipt,30))terms.push(copy('problem_30'));
              if(older)terms.push(copy('problem_later'));
              else if(noticed<=addYears(receipt,1))terms.push(copy('problem_1y'));
              else terms.push(copy('problem_2y'));
            }
            const outlet=value('outlet')==='yes',known=value('known_flaw');
            if(outlet)terms.push(copy(known==='yes'?'outlet_same':known==='no'?'outlet_other':'outlet_unknown'));
            const needsReview=legacy||older||(outlet&&known!=='no'),remedy=value('remedy');
            card(copy('problem_title'),[
              {heading:'cause_heading',lines:terms},
              {heading:'refund_heading',lines:needsReview?[copy('problem_review_solution')]:[copy(['refund','replace','repair','voucher'].includes(remedy)?'remedy_'+remedy:'remedy_unsure'),copy('problem_remedies')]},
              {heading:'transport_heading',lines:[copy(needsReview?'problem_review_shipping':'problem_shipping')]},
              {heading:'next_heading',lines:[copy('problem_next')]}
            ]);
          }
          if(purpose==='damage'){
            const lines=[copy('damage')];
            if(channel==='online'&&today<=weekendExtension(addDays(receipt,14)))lines.push(copy('damage_early'));
            card(copy('damage_title'),[{heading:'cause_heading',lines:lines},{heading:'next_heading',lines:[copy('damage_next')]}]);
          }
          finish();
        };
        root.querySelectorAll('[data-date]').forEach(input=>input.addEventListener('input',()=>{
          const digits=input.value.replace(/\D/g,'').slice(0,8);
          input.value=digits.slice(0,2)+(digits.length>2?'.'+digits.slice(2,4):'')+(digits.length>4?'.'+digits.slice(4):'');
        }));

        let openCalendar=null;
        root.querySelectorAll('[data-date]').forEach(input=>{
          const wrap=input.parentElement,button=wrap.querySelector('[data-calendar-open]'),panel=wrap.querySelector('[data-calendar]');
          const locale=root.dataset.language.toLowerCase().startsWith('ro')?'ro-RO':'en-GB';
          const label=root.querySelector('label[for="'+input.id+'"]');
          button.setAttribute('aria-label',button.getAttribute('aria-label')+': '+(label?label.textContent:''));
          panel.setAttribute('aria-label',label?label.textContent:button.getAttribute('aria-label'));
          let month,year;
          const close=(focus)=>{panel.hidden=true;button.setAttribute('aria-expanded','false');if(openCalendar&&openCalendar.panel===panel)openCalendar=null;if(focus)button.focus()};
          const draw=()=>{
            panel.replaceChildren();
            const header=document.createElement('div');header.className='lc-calendar-header';
            const nav=(name,symbol,delta)=>{const b=document.createElement('button');b.type='button';b.textContent=symbol;b.setAttribute('aria-label',copy(name));b.addEventListener('click',()=>{const date=new Date(Date.UTC(year,month+delta,1));year=date.getUTCFullYear();month=date.getUTCMonth();draw()});return b};
            header.appendChild(nav('calendar_prev','‹',-1));
            const months=document.createElement('select');months.setAttribute('aria-label',copy('calendar_month'));
            for(let m=0;m<12;m++){const opt=document.createElement('option');opt.value=String(m);opt.textContent=new Intl.DateTimeFormat(locale,{month:'long',timeZone:'UTC'}).format(new Date(Date.UTC(2026,m,1)));months.appendChild(opt)}
            months.value=String(month);months.addEventListener('change',()=>{month=Number(months.value);draw()});header.appendChild(months);
            const years=document.createElement('select');years.setAttribute('aria-label',copy('calendar_year'));
            const current=todayDate().getUTCFullYear();
            for(let y=Math.max(current,year);y>=Math.min(current-15,year);y--){const opt=document.createElement('option');opt.value=String(y);opt.textContent=String(y);years.appendChild(opt)}
            years.value=String(year);years.addEventListener('change',()=>{year=Number(years.value);draw()});header.appendChild(years);
            header.appendChild(nav('calendar_next','›',1));panel.appendChild(header);
            const week=document.createElement('div');week.className='lc-calendar-week';
            for(let i=0;i<7;i++){const cell=document.createElement('span');cell.textContent=new Intl.DateTimeFormat(locale,{weekday:'short',timeZone:'UTC'}).format(new Date(Date.UTC(2026,5,1+i)));week.appendChild(cell)}panel.appendChild(week);
            const days=document.createElement('div');days.className='lc-calendar-days';
            const offset=(new Date(Date.UTC(year,month,1)).getUTCDay()+6)%7,limit=new Date(Date.UTC(year,month+1,0)).getUTCDate(),selected=parse(input.value),today=todayDate();
            for(let i=0;i<offset;i++)days.appendChild(document.createElement('span'));
            for(let day=1;day<=limit;day++){
              const date=new Date(Date.UTC(year,month,day)),b=document.createElement('button');b.type='button';b.textContent=String(day);b.setAttribute('aria-label',fmt(date));b.setAttribute('aria-selected',String(!!selected&&date.getTime()===selected.getTime()));
              if(date.getTime()===today.getTime())b.setAttribute('aria-current','date');
              b.disabled=date>today;b.addEventListener('click',()=>{input.value=numeric(date);input.dispatchEvent(new Event('change',{bubbles:true}));close(true)});days.appendChild(b);
            }
            panel.appendChild(days);const dismiss=document.createElement('button');dismiss.type='button';dismiss.className='lc-calendar-close';dismiss.textContent=copy('calendar_close');dismiss.addEventListener('click',()=>close(true));panel.appendChild(dismiss);
          };
          button.addEventListener('click',()=>{
            if(!panel.hidden){close(true);return}
            if(openCalendar)openCalendar.close(false);
            const date=parse(input.value)||todayDate();month=date.getUTCMonth();year=date.getUTCFullYear();draw();panel.hidden=false;button.setAttribute('aria-expanded','true');openCalendar={panel,wrap,close};
            const selected=panel.querySelector('button[aria-selected="true"]')||panel.querySelector('.lc-calendar-days button:not(:disabled)');if(selected)selected.focus();
          });
          panel.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();close(true)}});
        });
        document.addEventListener('pointerdown',event=>{if(openCalendar&&!openCalendar.wrap.contains(event.target))openCalendar.close(false)});
        root.addEventListener('change',()=>{if(openCalendar&&openCalendar.wrap.closest('[data-conditional]')?.hidden)openCalendar.close(false)});

        refreshToday();root.addEventListener('change',()=>{update();result.hidden=true;result.replaceChildren()});root.addEventListener('input',()=>{update();result.hidden=true;result.replaceChildren()});
        root.querySelector('[data-calculate]').addEventListener('click',report);update();
      });
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
    document.addEventListener('shopify:section:load',event=>init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lisa-withdrawal-form"] && !Shopify.designMode) return;
  try {
    
function initLisaWithdrawal(scope) {
  scope.querySelectorAll('[data-lc-withdrawal]').forEach((root) => {
    if (root.dataset.withdrawalBound) return;
    const opener = root.querySelector('[data-withdrawal-open]');
    const dialog = root.querySelector('dialog');
    const close = root.querySelector('[data-withdrawal-close]');
    const frame = root.querySelector('[data-withdrawal-frame]');
    if (!opener || !dialog || !close || !frame || typeof dialog.showModal !== 'function') return;
    root.dataset.withdrawalBound = 'true';
    let previousOverflow;
    opener.addEventListener('click', (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (dialog.open) return;
      if (!frame.getAttribute('src')) frame.src = frame.dataset.src;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow || '';
      opener.focus();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initLisaWithdrawal(document), {once:true});
else initLisaWithdrawal(document);
document.addEventListener('shopify:section:load', (event) => initLisaWithdrawal(event.target));

  } catch(e) { console.error(e); }
})();
})();
